import styled from 'styled-components';
import { Breakpoints, Colors } from 'styles/Constants';

export const Section_body = styled.div`
  display: flex;
  align-items: center;

  flex-wrap: wrap;
  display: -webkit-flex;
  @media (max-width: ${Breakpoints.xxmedium}) {
    display: grid;
    button {
      width: 150px;
    }
  }
  input {
    width: 30%;
    margin-right: 2%;
    @media (max-width: ${Breakpoints.small}) {
      width: 100%;
      margin-bottom: 20px;
    }
  }
`;

export const HeardMargin = styled.div`
  white-space: pre-wrap;
  display: flex;
  align-items: center;
  margin-top: 20px;
  margin-bottom: 30px;
  alignitems: center;
  gap: 8px;

  .option {
    display: flex;
    margin-right: 10px;
    img {
      margin-top: 13px;
      margin-right: 5px;
      height: 20px;
      width: 20px;
    }
    svg {
      margin-top: 13px;
      margin-right: 5px;
    }
  }
`;

export const TextStyled = styled.p`
  margin-right: 10px;
  font-weight: 500;
  font-size: 14px;
  color: ${Colors.secondaryNormalGrey};
`;
